<template>
  <div>
      <router-view />
      <div class="mb">
        <ul class="nav-tab">
            <li>
                <a href="book.html">
                    <img src="assets/img/tab1.png" alt="">
                    <p>图书信息</p>
                </a>
            </li>
            <li class="on">
                <a href="index.html">
                    <img src="assets/img/tab2_on.png" alt="">
                    <p>地址找书</p>
                </a>
            </li>
            <li>
                <a href="center.html">
                    <img src="assets/img/tab3.png" alt="">
                    <p>个人中心</p>
                </a>
            </li>
        </ul>
    </div>
</div>
</template>

<script>

export default {
  name: 'NavMenuLayout'
}
</script>

<style scoped>

</style>
